var _polygon, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHoldPrevious = function SvgHoldPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.50293 4.5 6.48999 4.49915 5.75293 3.42615 5.01398 4.49915 5.00293 4.5 5.00201 4.51617 1.96002 8.94312 3.19604 9.79291 5.00201 7.16412 5.00293 14 6.50293 14 6.50201 7.16412 8.30981 9.79291 9.54584 8.94312 6.50201 4.51617 6.50293 4.5",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 1.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 1.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  })));
};

export default SvgHoldPrevious;